import type { MixedItemTag } from "../tag";
import type { QuestionVariant } from "./question";

export type ReportSessionType =
	| "DIAGNOSTIC"
	| "PRACTICETEST"
	| "STUDYPACK"
	| "SUMMATIVE"
	| "FORMATIVE";
export enum Confidence {
	low = 0,
	medium = 50,
	high = 100,
}

export type SessionItemTypes =
	| "ACTION"
	| "BLOCK"
	| "CHOICE"
	| "CST"
	| "PASSAGE"
	| "QUESTION"
	| "SECTION";

interface Score {
	value: number;
}

interface PointList {
	choiceId: string;
	points?: number;
}

export interface Answers {
	numDistractors: number;
	score: number;
	selectedChoiceIds: string[];
	timeTaken: number;
	isCorrect: boolean;
	answerText: string;
	selectedaction: boolean;
	pointsList?: PointList[];
}

interface BaseItem {
	id: string;
	containerId?: string;
	stem: string;
	displayName?: string;
	itemType: SessionItemTypes;
	currentScore?: Score;
	previousScore?: Score;
	numAttempts?: number;
	tags?: MixedItemTag[];
	variant?: QuestionVariant;
	sequenceOrder?: string[];
	numRequiredAnswers?: number;
	parentStem?: string;
	sessionConfig?: string;
	lastUpdated?: boolean;
}
export interface SessionChildItem extends BaseItem {
	instruction?: string;
	isCorrect?: boolean;
	explanation?: string;
	feedback?: string;
	text: string;
	stem: string;
	numAttempts?: number;
	answers?: Answers;
	children?: SessionChildItem[];
	numFirstSelections: number;
	parentStem?: string;
	points?: number;
	marked?: boolean;
	highlight?: string;
	crossOut?: string[];
	maxChoiceCount?: number;
	minChoiceCount?: number;
	video?: string;
}

export type StudySessionContextType = "SAMPLE" | "SELECTION";

export type EndSessionTypes = "FORMATIVE" | "SUMMATIVE";

export interface EndMixedSessionInput {
	sessionId: string;
	userId: string;
	numericId?: number;
	sessionType: EndSessionTypes;
}

export type Mode = "FLIP" | "MATCH" | "QUESTION" | "QUIZ" | "CST";

export type Hint = {
	id: string;
	text: string;
};
